<template>

  <head>

    <meta charset="utf-8"/>
    <title>Desk Birdy | Business Permits</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
          rel="stylesheet">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link href="./assets/libs/owl.carousel/assets/owl.carousel.min.css" rel="stylesheet">

    <link href="./assets/libs/owl.carousel/assets/owl.theme.default.min.css" rel="stylesheet">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

  </head>

  <body @contextmenu.prevent data-sidebar="dark">


  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Business Permits</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="cert-biz-stats.html">Business Permits</a>
                    </li>
                    <li class="breadcrumb-item active"> Applications Pending</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- tool bar -->

          <ToolBar/>

          <!-- end of toolbar -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-header bg-primar text-white border-bottom d-flex justify-content-between align-items-center py-3">
                  <h4 class="card-title text-whit text-uppercase mb-0">Records Pending Review for {{subCountyFilter.subCountyName}}</h4>
                  <div>

                    <div class="flex-start d-flex align-items-center">



                      <!-- Sub County Dropdown -->
                      <div class="input-group input-group-sm">
                        <label class="input-group-text">Sub County</label>
                        <select class="form-select" @change="getWardsFilter(subCountyFilter.subCountyID)" v-model="subCountyFilter">
                          <option value="{}">Select All Sub Counties</option>
                          <option :key="index" :value="item"
                                  v-for="(item, index) in subCountiesFilter">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>

                      <!-- Ward Dropdown -->
                      <div class="input-group mx-4 input-group-sm">
                        <label class="input-group-text">Ward</label>
                        <select class="form-select"  v-model="wardFilter">
                          <option value="{}">Select All Wards</option>
                          <option :key="index" :value="item"
                                  v-for="(item, index) in wardsFilter">
                            {{ item.wardName }}
                          </option>
                          <!-- Add more wards as needed -->
                        </select>
                      </div>

                      <!-- Zone/Market Dropdown -->
                      <div class="input-group input-group-sm me-3">
                        <label class="input-group-text">Zone/Market</label>
                        <select class="form-select"  @change="selectedZoneFilter($event)">
                          <option value="{}">Select All Zones</option>
                          <option :key="index" :value="JSON.stringify(item)"
                                  v-for="(item, index) in zonesFilter">
                            {{ item.zone }}
                          </option>
                          <!-- Add more markets as needed -->
                        </select>
                      </div>


                    </div>
                  </div>
                </div>

                <div class="card-header bg-soft border-bottom d-flex justify-content-between align-items-center py-3 bg-warning ">
                  <p class="pb-0 text-capitalize text-black fw-bold mb-0">Please verify the details before sending as an invoice. Once sent, the customer will receive it as is. Note that you cannot edit the category or subcategory, but you can correct any other data before submission.</p>
                </div>

                <!-- =========================================================================== -->
                <!-- BUSINESS READINESS CHECK COMPONENT -->
                <!-- =========================================================================== -->
                <BusinessReadinessModal
                    ref="readinessModal"
                    :entries="entries"
                    :fiscal-year="defaultFiscalYear"
                    :show="true"
                    :total-pending-records="totalPendingRecords"
                    :sub-county-name="subCountyFilter.subCountyName || ''"
                    :ward-name="wardFilter.wardName || ''"
                    :zone="zoneNameFilter || ''"
                    @readiness-checked="onReadinessChecked"
                    @initiate-update="onInitiateUpdate"
                    @scanning-changed="onScanningChanged"
                    @paused-changed="onPausedChanged"
                />

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 align-items-center  animated" role="toolbar">
                    <button
                        @click="openSelectedInvoiceModal()"
                        type="button"
                        class="btn btn-success waves-effect btn-label waves-light me-3 text-uppercase"
                        data-bs-toggle="modal"
                        data-bs-target=".otp-modal"
                        :disabled="!scanCompleted || isScanning || isPaused || hasUnreadySelectedBusinesses || selectedCount === 0"
                        :title="getInvoiceButtonTitle()"
                    >
                      <i class="bx bx-paper-plane label-icon"></i> Send Invoices
                      <span v-if="isScanning || isPaused" class="spinner-border spinner-border-sm ms-1"></span>
                    </button>

                    <!-- New Send All Button -->
                    <button
                        @click="openSendAllModal()"
                        type="button"
                        class="btn btn-primary waves-effect btn-label waves-light me-3 text-uppercase"
                        data-bs-toggle="modal"
                        data-bs-target=".otp-modal"
                        :disabled="!scanCompleted || isScanning || isPaused || readinessSummary.notReady > 0"
                        :title="getSendAllButtonTitle()"
                    >
                      <i class="bx bx-send label-icon"></i> Send All ({{ numberFormat(readyForInvoicingCount) }})
                      <span v-if="isScanning || isPaused" class="spinner-border spinner-border-sm ms-1"></span>
                    </button>
                  </div>
                </div>


                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom d-flex">
                  <div class="d-flex align-items-center justify-content-center p-3 flex-grow-1"  role="toolbar">
                    <form class="app-search p-0 m-0 w-100">
                      <div class="position-relative">
                        <input v-model="search" type="text" class="form-control w-100" placeholder="Search... eg Business Name, ID Number, Bill Number, etc" spellcheck="false" data-ms-editor="true">
                        <span class="bx bx-search-alt"></span>
                      </div>
                    </form>
                  </div>
                  <div class="pr-3">
                    <button  v-if="getRight('DOWNLOAD REPORTS')" @click="downloadReportPDF()" class="btn btn-primary">Download </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-wrapper">
                    <table class="table table-striped table-sm align-middle bulk-invoicer-table">
                      <thead class="bg-info text-black text-uppercase border border-info">
                      <tr>
                        <th class="col-business">
                          <input
                              class="form-check-input mt-0 pt-0 form-check-dark"
                              type="checkbox"
                              id="selectAll"
                              @change="toggleSelectAll"
                              :checked="allSelected"
                          >
                          <label for="selectAll" class="mx-2 mb-0">Business</label>
                        </th>
                        <th class="col-id">ID</th>
                        <th class="col-ready">Ready</th>
                        <th class="col-status">Status</th>
                        <th class="col-owner">Owner</th>
                        <th class="col-date">Registered</th>
                        <th class="col-category">Category</th>
                        <th class="col-invoice">Invoice</th>
                        <th class="col-amount">Invoiced</th>
                        <th class="col-paid">Paid</th>
                        <th class="col-actions">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in entries" :key="index">
                        <td class="col-business">
                          <div class="d-flex align-items-center">
                            <input
                                class="form-check-input me-2 flex-shrink-0"
                                type="checkbox"
                                v-model="item.selected"
                                :disabled="item.isReady === false"
                                :title="item.isReady === false ? 'This business needs fee setup before invoicing' : ''"
                            >
                            <div class="text-truncate-wrapper">
                              <div class="fw-bold text-truncate" :title="item.businessName">{{item.businessName || '-'}}</div>
                              <small class="text-info text-truncate d-block" :title="item.subCountyName + ' | ' + item.wardName">
                                {{item.subCountyName}} | {{item.wardName}}
                              </small>
                            </div>
                          </div>
                        </td>
                        <td class="col-id">{{ item.businessID }}</td>
                        <td class="col-ready">
                          <span v-if="item.isReady === true" class="badge bg-success" title="Ready for invoicing">✓</span>
                          <span v-else-if="item.isReady === false" class="badge bg-danger" title="No fee records - needs setup">✗</span>
                          <span v-else class="badge bg-secondary" title="Checking...">...</span>
                        </td>
                        <td class="col-status">
                          <span v-if="item.renewalStatus === 'INVOICED'" class="badge bg-success small-badge">INV</span>
                          <span v-else-if="item.renewalStatus === 'ARCHIVED'" class="badge bg-danger small-badge">ARC</span>
                          <span v-else-if="item.renewalStatus === 'PENDING'" class="badge bg-warning text-dark small-badge">PEN</span>
                          <span v-else-if="item.renewalStatus === 'UPDATED'" class="badge bg-info small-badge">UPD</span>
                        </td>
                        <td class="col-owner">
                          <div class="text-truncate" :title="(item.owner || '') + ' ' + (item.ownerPhone || '')">
                            {{ item.ownerPhone || '-' }}
                          </div>
                        </td>
                        <td class="col-date">
                          <span :title="formattedDate(item.registeredOn)">{{ shortDate(item.registeredOn) }}</span>
                        </td>
                        <td class="col-category">
                          <div class="text-truncate" :title="item.feeDescription || item.newFeeDescription || ''">
                            {{ item.feeDescription || item.newFeeDescription || '-' }}
                          </div>
                        </td>
                        <td class="col-invoice">
                          <div class="text-truncate" :title="item.billNo || item.newBillNo || ''">
                            {{ item.billNo || item.newBillNo || '-' }}
                          </div>
                        </td>
                        <td class="col-amount text-end">{{ formatPriceShort(item.billTotal || item.newAmount) }}</td>
                        <td class="col-paid text-end">{{ formatPriceShort(item.receiptAmount || item.newPaidAmount) }}</td>
                        <td class="col-actions">
                          <div class="btn-group btn-group-sm">
                            <button
                                @click="getBusinessDetails(item.id, index)"
                                class="btn btn-outline-dark btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target=".details-modal"
                                title="View Details"
                            >
                              <i class="bx bx-show"></i>
                            </button>
                            <button
                                @click="getBusinessDetails(item.id, index)"
                                class="btn btn-success btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target=".receipting-modal"
                                title="Initiate Verification"
                            >
                              <span v-if="loadingIndex === index" class="spinner-border spinner-border-sm"></span>
                              <i v-else class="bx bx-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center"
                         v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. It will be ready soon. Please wait
                          and have fun. Thank you for your interest.</p>

                      </div>
                    </div>
                    <div class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center"
                         v-if="businesses.length<1 & loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" alt="No search results"
                             class="img mb-4"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter
                        criteria. Please try using different keywords or filters.</p>
                    </div>

                  </div>
                </div>
                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example "
                       class="d-flex align-items-center justify-content-between">

                    <div class="d-flex align-items-center">
                                            <span class="pr-3 pb-0 mb-0 font-13px">
                                                <span>Rows Per Page</span>
                                            </span>
                      <select class="form-select w-auto font-13px " v-model="pageSize">
                        <option value="5">5 Rows</option>
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                        <option value="5000">5000 Rows</option>
                        <option value="10000">5000 Rows</option>
                        <option value="1000000000000000">All Rows</option>
                      </select>
                    </div>

                    <ul class="pagination">
                      <!-- add a class of disabled and an attribute of disabled when the current page is the first page -->
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a href="javascript: void(0);" :disabled="currentPage === 1" @click="prevPage" class="page-link"
                           tabindex="-1">Previous</a>
                      </li>
                      <!-- replace the v-for directive with the pagination function call -->
                      <li href="javascript: void(0);" :class="{ active: currentPage === page }" :key="page" class="page-item"
                          v-for="page in pagination(currentPage, totalPages, 3)">
                        <!-- check if the page is an ellipsis and display it as plain text -->
                        <span class="page-link" v-if="page === '...'">{{ page }}</span>
                        <!-- otherwise, display it as a clickable link -->
                        <a href="javascript: void(0);" @click="goToPage(page)" class="page-link" v-else>{{ page }}</a>
                      </li>
                      <!-- add a class of disabled and an attribute of disabled when the current page is the last page -->
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a href="javascript: void(0);" :disabled="currentPage === totalPages" @click="nextPage"
                           class="page-link">Next</a>
                      </li>
                    </ul>


                  </nav>
                </div>

              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Modal Components -->
      <ReceiptingModal
          :businessDetails="businessDetails"
          :entry="entry"
          :billDetail="billDetail"
          :statuses="statuses"
          :subCounties="subCounties"
          :subCounty="subCounty"
          :wards="wards"
          :ward="ward"
          :zones="zones"
          :zone="zone"
          :floors="floors"
          :floor="floor"
          :tradeCategories="tradeCategories"
          :tradeCategory="tradeCategory"
          :tradeSubCategories="tradeSubCategories"
          :tradeSubCategory="tradeSubCategory"
          :tradeSubCategoriesOther="tradeSubCategoriesOther"
          :checkedItems="checkedItems"
          :totalFeeAmount="totalFeeAmount"
          :validationAction="validationAction"
          :archiveReason="archiveReason"
          :otherReason="otherReason"
          :remarks="remarks"
          :loading="loading"
          :penalized="penalized"
          :isDataLoading="loadingBusinessDetails"
          @update:businessDetails="businessDetails = $event"
          @update:subCounty="subCounty = $event"
          @update:ward="ward = $event"
          @update:zone="zone = $event"
          @update:floor="floor = $event"
          @update:tradeCategory="tradeCategory = $event"
          @update:tradeSubCategory="tradeSubCategory = $event"
          @update:checkedItems="checkedItems = $event"
          @update:validationAction="validationAction = $event"
          @update:archiveReason="archiveReason = $event"
          @update:otherReason="otherReason = $event"
          @update:remarks="remarks = $event"
          @update:penalized="penalized = $event"
          @getWards="getWards"
          @getTradeSubCategory="getTradeSubCategory"
          @printBill="printBill"
          @printReceipt="printReceipt"
          @archiveBusiness="archiveInvoicedStatus"
          @updateOnly="updateBusinessForRenewal"
          @generateInvoice="updateBusinessForRenewalThenGenerateBill"
          @sendOTPMessage="proceedToGenerateBill"
          @modalClosed="onReceiptingModalClosed"
      />

      <DetailsModal
          :businessDetails="businessDetails"
          :entry="entry"
          :billDetail="billDetail"
          :billDetailNew="billDetailNew"
          :billInfo="billInfo"
          :billInfoNew="billInfoNew"
          :changesDone="changesDone"
          @printBill="printBill"
          @printReceipt="printReceipt"
      />

      <InvoicedRecordModal
          :businessDetails="businessDetails"
          :entry="entry"
          :billDetails="billDetails"
          :billInfo="billInfo"
          @printBill="printBill"
      />

      <OTPModal
          ref="otpModal"
          :selectedCount="selectedReadyCount"
          :totalEntries="entries.length"
          :totalPendingRecords="readyForInvoicingCount"
          :sessionPhoneNumber="sessionPhoneNumber"
          :invoicesSentSuccess="invoicesSentSuccess"
          :loading="loading"
          :loadingOTP="loadingOTP"
          :message="message"
          :otpCodes="otpCodes"
          :batchSize="batchSize"
          :fiscalYear="selectedFiscalYear"
          @update:otpCodes="otpCodes = $event"
          @update:fiscalYear="selectedFiscalYear = $event"
          @sendOTPMessage="sendOTPMessage"
          @verifyOTP="verifyOTP"
          @verifySendAllOTP="verifySendAllOTP"
          @goToNewRegister="gotTo('new-register')"
      />

      <!-- Batch Progress Modal -->
      <BatchProgressModal
          :isProcessing="batchProgress.isProcessing"
          :isPaused="batchProgress.isPaused"
          :isCompleted="batchProgress.isCompleted"
          :hasErrors="batchProgress.errorLog.length > 0"
          :totalToProcess="batchProgress.totalToProcess"
          :processedCount="batchProgress.processedCount"
          :successCount="batchProgress.successCount"
          :errorCount="batchProgress.errorCount"
          :skippedCount="batchProgress.skippedCount"
          :currentBatch="batchProgress.currentBatch"
          :totalBatches="batchProgress.totalBatches"
          :currentPage="batchProgress.currentPage"
          :totalPages="batchProgress.totalPages"
          :batchSize="batchSize"
          :elapsedTime="batchProgress.elapsedTime"
          :estimatedTimeRemaining="batchProgress.estimatedTimeRemaining"
          :errorLog="batchProgress.errorLog"
          :currentItem="batchProgress.currentItem"
          :fiscalYear="selectedFiscalYear"
          @pause="pauseBatchProcessing"
          @resume="resumeBatchProcessing"
          @cancel="cancelBatchProcessing"
          @retryErrors="retryFailedRecords"
          @close="closeBatchProgressModal"
      />

      <footer class="footer">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                County Government
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>

</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/bulk/ToolBarBulk";
import ReceiptingModal from "@/components/sbp/bulk/modals/ReceiptingModal";
import DetailsModal from "@/components/sbp/bulk/modals/DetailsModal";
import InvoicedRecordModal from "@/components/sbp/bulk/modals/InvoicedRecordModal";
import OTPModal from "@/components/sbp/bulk/modals/OTPModal";
import BatchProgressModal from "@/components/sbp/bulk/modals/BatchProgressModal";
import BusinessReadinessModal from "@/components/sbp/bulk/modals/BusinessReadinessModal";
import router from "@/router";
import {authUrl, biller, execute, executeDownload, getRight, trade} from "@/api";
import moment from 'moment'

export default {
  name: "BulkInvoicer",
  components: {
    ToolBar,
    NavigationBar,
    ReceiptingModal,
    DetailsModal,
    InvoicedRecordModal,
    OTPModal,
    BatchProgressModal,
    BusinessReadinessModal
  },
  data() {
    return {
      invoicesSentSuccess:false,
      indexPosition:'',
      loadingIndex: null,
      loadingBusinessDetails: false, // Track when business details are loading for modal
      otp:'',
      otpCodes:'',
      sessionPhoneNumber:'',
      search:'',
      loading: false,
      loadingOTP: false,
      // set the initial current page as 1
      currentPage: 1,
      // set the total number of pages as 10 (you can change this according to your data source)
      totalPages: 0,
      // set the number of items per page as 5 (you can change this according to your preference)
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },
      totalAmount: 0,
      selectedItem: null,
      valueItem: "",
      itemList: [{
        id: null,
        value: null
      }],
      wards: [{
        wardID: "",
        wardName: ""
      }],
      wardsFilter: [],
      filter: '',
      dateFrom: '',
      dateTo: '',
      message: '',
      alert: {
        success: false,
        info: false,
        failed: false
      },
      billInfoTotal: 0,
      billNo: '',
      penalized: false,
      businessDetailsOriginal: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null,
        buildingName: null,
        buildingOccupancy: null,
        floorNo: null,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail: null,
        postalAddress: null,
        postalCode: null,
        businessPhone: null,
        contactPersonNames: null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: 0.0,
        lng: 0.0
      },
      businessDetails: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null,
        buildingName: null,
        buildingOccupancy: null,
        floorNo: null,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail: null,
        postalAddress: null,
        postalCode: null,
        businessPhone: null,
        contactPersonNames: null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: 0.0,
        lng: 0.0
      },
      billDetail: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        description: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        status: null,
        dateCreated: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        category: null
      },
      billDetailNew: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        description: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        status: null,
        dateCreated: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        category: null
      },
      billDetails: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        description: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        status: null,
        dateCreated: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        category: null
      },
      businesses: [
        {
          id: null,
          billNo: null,
          businessID: null,
          businessName: null,
          businessSubCategory: null,
          duration: null,
          billTotal: null,
          receiptAmount: null,
          billBalance: null,
          startDate: null,
          endDate: null,
          statusID: null,
          status: null,
          printable: null,
          issuingOfficer: null,
          designation: null,
          dateOfIssue: null,
          stageStatus: null
        }],
      entries: [{
        remarks:null,
        subCountyName:null,
        wardName:null,
        zone: null,
        businessID: null,
        renewalStatus: null,
        businessName: null,
        owner: null,
        ownerPhone: null,
        registeredOn: null,
        registeredBy: null,
        feeDescription: null,
        billNo: null,
        changesCount: null,
        billTotal: null,
        receiptAmount: null,
        selected: false,
        isReady: null // Track readiness status
      }],
      feesAndCharges: {
        feeId: null,
        feeDescription: null,
        unitOfMeasure: null,
        unitFeeAmount: null,
        accountNo: null,
        incomeTypeId: null,
        feeType: null,
        accountDesc: null,
        costCenterNo: null,
        zone: null,
        typeDescription: null,
        prorated: null,
        duration: null,
        incomeTypeDescription: null,
        incomeTypePrefix: null,
        fundDescription: null,
        status: null,
        departmentID: null,
        zoneCategoryID: null,
        zoneCategory: null
      },
      receiptDetails: {
        id: null,
        receiptNo: null,
        billNo: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null,
        costCenterNo: null,
        accountNo: null,
        incomeTypeDescription: null,
        feeID: null,
        feeDescription: null,
        wardID: null,
        subCountyID: null,
        subCountyName: null,
        wardName: null,
        currency: null,
        source: null,
        transactionCode: null,
        paidBy: null,
        dateCreated: null,
        dateModified: null,
        createdBy: null,
        modifiedBy: null,
        isActive: null,
        status: null,
        zone: null,
        departmentID: null,
        department: null,
        idNo: null,
        phoneNumber: null,
        names: null,
        customerPhoneNumber: null,
        description: null,
        category: null
      },
      receiptInfos: [
        {
          id: null,
          receiptNo: null,
          billNo: null,
          feeID: null,
          feeDescription: null,
          billTotal: null,
          receiptAmount: null,
          billBalance: null,
          customer: null,
          clientPhoneNo: null,
          description: null,
          receiptDate: null,
          printCount: null,
          wardID: null,
          subCountyID: null,
          subCountyName: null,
          wardName: null,
          dateCreated: null,
          dateModified: null,
          createdBy: null,
          modifiedBy: null,
          printedBy: null,
          updated: null,
          isActive: null,
          status: null,
          zone: null,
          departmentID: null,
          department: null,
          idNo: null,
          phoneNumber: null,
          names: null,
          customerPhoneNumber: null,
          category: null
        }],
      tradeCategories: [{
        incomeTypeId: null,
        incomeTypeDescription: null,
        incomeTypePrefix: null,
        fundDescription: null,
        status: null,
        departmentID: null,
        zoneCategoryID: null,
        zoneCategory: null
      }],
      tradeCategory:{
        incomeTypeId: null,
        incomeTypeDescription: null,
        incomeTypePrefix: null,
        fundDescription: null,
        status: null,
        departmentID: null,
        zoneCategoryID: null,
        zoneCategory: null
      },
      tradeSubCategories: [
        {
          feeId: null,
          feeDescription: null,
          unitOfMeasure: null,
          unitFeeAmount: null,
          accountNo: null,
          incomeTypeId: null,
          feeType: null,
          accountDesc: null,
          costCenterNo: null,
          zone: null,
          typeDescription: null,
          prorated: null,
          duration: null
        }
      ],
      billInfo: [
        {
          id: null,
          billNo: null,
          feeID: null,
          feeDescription: null,
          fiscalYear: null,
          paymentCode: null,
          customer: null,
          description: null,
          periodID: null,
          wardID: null,
          subCountyID: null,
          subCountyName: null,
          wardName: null,
          createdBy: null,
          billTotal: null,
          receiptAmount: null,
          billBalance: null,
          status: null,
          dateCreated: null,
          zone: null,
          departmentID: null,
          department: null,
          idNo: null,
          phoneNumber: null,
          names: null,
          customerPhoneNumber: null,
          category: null,
          incomeTypePrefix: null,
          quantity: null
        }
      ],
      billInfoNew: [
        {
          id: null,
          billNo: null,
          feeID: null,
          feeDescription: null,
          fiscalYear: null,
          paymentCode: null,
          customer: null,
          description: null,
          periodID: null,
          wardID: null,
          subCountyID: null,
          subCountyName: null,
          wardName: null,
          createdBy: null,
          billTotal: null,
          receiptAmount: null,
          billBalance: null,
          status: null,
          dateCreated: null,
          zone: null,
          departmentID: null,
          department: null,
          idNo: null,
          phoneNumber: null,
          names: null,
          customerPhoneNumber: null,
          category: null,
          incomeTypePrefix: null,
          quantity: null
        }
      ],
      tradeSubCategoriesOther: [
        {
          feeId: null,
          feeDescription: null,
          unitOfMeasure: null,
          unitFeeAmount: null,
          accountNo: null,
          incomeTypeId: null,
          feeType: null,
          accountDesc: null,
          costCenterNo: null,
          zone: null,
          typeDescription: null,
          prorated: null,
          duration: null
        }
      ],
      tradeSubCategory: {
        feeId: null,
        feeDescription: null,
        unitOfMeasure: null,
        unitFeeAmount: null,
        accountNo: null,
        incomeTypeId: null,
        feeType: null,
        accountDesc: null,
        costCenterNo: null,
        zone: null,
        typeDescription: null,
        prorated: null,
        duration: null
      },
      statuses: [{
        id: null,
        businessID: null,
        statusID: null,
        status: null,
        description: null,
        dateCreated: null,
        completed: true,
        billNo: null,
        comments: null,
        issuingOfficer: null,
        updatedDate: null,
        location: null
      }],
      subCounties:[],
      subCountiesFilter:[],

      subCounty: {
        id:"",
        countyID:"",
        countyName:"",
        subCountyID:"",
        subCountyName:"",
        wardID:"",
        wardName:"",
        status:""
      },
      subCountyFilter: {
        id:"",
        countyID:"",
        countyName:"",
        subCountyID:"",
        subCountyName:"",
        wardID:"",
        wardName:"",
        status:""
      },
      ward:{
        id:"",
        countyID:"",
        countyName:"",
        subCountyID:"",
        subCountyName:"",
        wardID:"",
        wardName:"",
        status:""
      },
      wardFilter:{
        id:"",
        countyID:"",
        countyName:"",
        subCountyID:"",
        subCountyName:"",
        wardID:"",
        wardName:"",
        status:""
      },
      zone:null,
      zones: [],
      zonesFilter: [],
      floors:[],
      floor:{},
      entry: {
        id: null,
        billNo: null,
        businessID: null,
        businessName: null,
        duration: null,
        billTotal: null,
        receiptAmount: null,
        billBalance: null,
        startDate: null,
        endDate: null,
        statusID: null,
        status: null,
        printable: null,
        issuingOfficer: null,
        designation: null,
        dateOfIssue: null,
        stageStatus: null,
        comments: null,
        incomeTypeId: null,
        feeID: null,
        feeDescription: null,
        subCountyName: null,
        wardName: null,
        dateCreated: null,
        subCountyID: null,
        wardID: null,
        code: null,
        brimsCode: null,
        plotNumber: null,
        fiscalYear: null,
        printCount: null,
        receiptedBy: null,
        renewalStatus: null,
        owner: null,
        ownerPhone: null,
        registeredOn: null,
        registeredBy: null,
        changesCount: null,
        year: null,
        changesDone:null,
        remarks:null
      },
      precheckedFeeIDs: [],
      checkedItems: [],
      totalFeeAmount: 0,
      validationAction: "approve",
      archiveReason:'',
      otherReason:'',
      printable:'',


      /*Generate Bill*/
      transactionCompleted: false,
      transactionSummary: false,
      paymentPanel: true,
      paymentMethod: false,
      billItem:[],
      paymentData: {
        bankReceiptNo: null,
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
        paymentMode:null,
        sessionNames:null,
        sessionIdNo:null,
        sessionPhoneNumber:null
      },

      feesAndChargeItems:[{
        feeId: null,
        feeDescription: null,
        unitOfMeasure: null,
        unitFeeAmount: null,
        accountNo: null,
        incomeTypeId: null,
        feeType: null,
        accountDesc:null ,
        costCenterNo:null,
        zone: null,
        typeDescription: null,
        customer: null,
        quantity: 1
      }],
      changesDone:[
        {
          key: "businessName",
          originalName:"Osongo Buzna",
          newName:"Osambama"
        }
      ],
      billingChange:'NORMAL',
      subCountyNameFilter:'',
      wardNameFilter:'',
      zoneNameFilter:'',
      statusCounts:'',
      totalPaidAmount:0,
      remarks:'',

      // =========================================================================
      // FISCAL YEAR SELECTION
      // =========================================================================
      selectedFiscalYear: null,

      // =========================================================================
      // BUSINESS READINESS DATA
      // =========================================================================
      readinessSummary: {
        total: 0,
        ready: 0,
        notReady: 0,
        fiscalYear: ''
      },
      isScanning: false, // Track if scanning is in progress
      isPaused: false, // Track if scanning is paused
      scanCompleted: false, // Track if scan has completed
      lastUpdatedBusinessID: null, // Track which business was last sent for update

      // =========================================================================
      // BATCH PROCESSING VARIABLES
      // =========================================================================
      batchSize: 10,
      totalPendingRecords: 0,
      batchProgress: {
        isProcessing: false,
        isPaused: false,
        isCompleted: false,
        totalToProcess: 0,
        processedCount: 0,
        successCount: 0,
        errorCount: 0,
        skippedCount: 0,
        currentBatch: 0,
        totalBatches: 0,
        currentPage: 1,
        totalPages: 1,
        elapsedTime: 0,
        estimatedTimeRemaining: 0,
        errorLog: [],
        currentItem: null,
        startTime: null,
        failedRecords: []
      },
      batchTimer: null,
      batchProcessingController: null
    }

  },
  watch: {
    pageSize(newPageSize) {
      this.getPreviousRegister()
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;

    },
    search(){
      this.getPreviousRegister()
    },
    checkedItems(newCheckedItems) {
      this.totalFeeAmount = newCheckedItems.reduce((sum, item) => sum + parseFloat(item.unitFeeAmount || 0), 0);
    },
    ward(){
      this.businessDetails.wardName = this.ward.wardName
      this.businessDetails.wardID = this.ward.wardID
    },
    zone(){
      this.businessDetails.zone = this.zone
    },
    subCountyFilter(){
      this.wardFilter ={}
      this.zoneNameFilter =''
      this.getPreviousRegister()
    },
    wardFilter(){
      this.zoneNameFilter =''
      this.getPreviousRegister()
    },
    zoneNameFilter(){
      this.getPreviousRegister()
    }

  },
  computed: {
    selectedCount() {
      return this.entries.filter(entry => entry.selected).length;
    },
    // Count only selected entries that are ready
    selectedReadyCount() {
      return this.entries.filter(entry => entry.selected && entry.isReady === true).length;
    },
    allSelected() {
      return this.entries.every(entry => entry.selected);
    },
    // Check if any selected business is not ready
    hasUnreadySelectedBusinesses() {
      return this.entries.some(entry => entry.selected && entry.isReady === false);
    },
    // Count of businesses ready for invoicing
    readyForInvoicingCount() {
      return this.totalPendingRecords - (this.readinessSummary.notReady || 0);
    },
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },

    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.billBalance), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.detailAmount), 0));
    },
    defaultFiscalYear() {
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();
      if (currentMonth >= 9) {
        return currentYear + 1;
      }
      return currentYear;
    }
  },
  mounted() {

    this.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber")

    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD')
    this.dateTo = moment().format('YYYY-MM-DD')

    this.selectedFiscalYear = this.defaultFiscalYear;

    this.getPreviousRegister()
    this.getTotalPendingCount()

    this.$watch('dateFrom', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {

      } else {
        this.getPreviousRegister()
      }

    })
    this.$watch('dateTo', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {

      } else {
        this.getPreviousRegister()
      }
    })

    this.getSubCountiesFilter()
    this.menuAccess()

    const otpModalEl = document.querySelector('.otp-modal');
    if (otpModalEl) {
      otpModalEl.addEventListener('hidden.bs.modal', () => {
        if (this.$refs.otpModal) {
          this.$refs.otpModal.resetState();
        }
      });
    }
  },
  beforeDestroy() {
    if (this.batchTimer) {
      clearInterval(this.batchTimer);
    }
  },
  methods: {
    // =========================================================================
    // BUSINESS READINESS EVENT HANDLERS
    // =========================================================================
    onReadinessChecked(data) {
      // Store readiness summary data from the modal
      this.readinessSummary = data.summary || {
        total: 0,
        ready: 0,
        notReady: 0,
        fiscalYear: ''
      };
      // Mark scan as completed if we have data
      if (this.readinessSummary.total > 0 || this.readinessSummary.ready > 0 || this.readinessSummary.notReady > 0) {
        this.scanCompleted = true;
      } else {
        this.scanCompleted = false;
      }
      console.log("Readiness scan complete:", this.readinessSummary);
    },

    // Handle scanning state changes
    onScanningChanged(isScanning) {
      this.isScanning = isScanning;
      // Reset scanCompleted when starting a new scan
      if (isScanning) {
        this.scanCompleted = false;
      }
    },

    // Handle paused state changes
    onPausedChanged(isPaused) {
      this.isPaused = isPaused;
    },

    // Trigger re-scan when needed
    triggerReadinessScan() {
      if (this.$refs.readinessModal) {
        this.$refs.readinessModal.startFullScan();
      }
    },

    // Get title for Send Invoices button
    getInvoiceButtonTitle() {
      if (!this.scanCompleted) {
        return 'Please complete the business readiness scan first';
      }
      if (this.isScanning) {
        return 'Please wait for scanning to complete';
      }
      if (this.isPaused) {
        return 'Scanning is paused - resume or cancel to continue';
      }
      if (this.hasUnreadySelectedBusinesses) {
        return 'Some selected businesses need fee setup first';
      }
      if (this.selectedCount === 0) {
        return 'Select businesses to invoice';
      }
      return '';
    },

    // Get title for Send All button
    getSendAllButtonTitle() {
      if (!this.scanCompleted) {
        return 'Please complete the business readiness scan first';
      }
      if (this.isScanning) {
        return 'Please wait for scanning to complete';
      }
      if (this.isPaused) {
        return 'Scanning is paused - resume or cancel to continue';
      }
      if (this.readinessSummary.notReady > 0) {
        return this.readinessSummary.notReady + ' businesses need fee setup first';
      }
      return '';
    },

    onInitiateUpdate(data) {
      // This is called when user clicks "Update" in the readiness modal
      // It calls the same function as "Initiate Verification" button

      // Track which business is being updated (for removal after update)
      this.lastUpdatedBusinessID = data.businessID;

      // Find the entry in the main entries array
      const entryIndex = this.entries.findIndex(e => e.businessID === data.businessID);

      if (entryIndex !== -1) {
        // Get business details and open the receipting modal
        this.getBusinessDetails(this.entries[entryIndex].id, entryIndex);

        // Open the receipting modal after a short delay to allow data to load
        this.$nextTick(() => {
          setTimeout(() => {
            var receiptingModal = new bootstrap.Modal($('.receipting-modal')[0]);
            receiptingModal.show();
          }, 500);
        });
      } else {
        // Business not in current page, try to fetch by ID
        alert("Business not found in current page. Please search for: " + data.businessID);
      }
    },

    // Called when receipting modal closes
    onReceiptingModalClosed() {
      console.log("Receipting modal closed, last updated business:", this.lastUpdatedBusinessID);

      // Tell the readiness modal to remove the updated business from its list
      if (this.lastUpdatedBusinessID && this.$refs.readinessModal) {
        this.$refs.readinessModal.onUpdateCompleted(this.lastUpdatedBusinessID);
      }

      // Reset tracking
      this.lastUpdatedBusinessID = null;

      // Reset parent data
      this.businessDetails = {};
      this.billDetail = {};
      this.tradeCategory = {};
      this.tradeSubCategory = {};
      this.checkedItems = [];
    },

    // =========================================================================
    // GET FILTERED ENTRIES WITH FISCAL YEAR
    // =========================================================================
    getFilteredEntries() {
      // Filter entries where selected is true AND isReady is true, add fiscalYear
      return this.entries
          .filter((entry) => entry.selected && entry.isReady === true)
          .map((entry) => ({
            ...entry,
            fiscalYear: this.selectedFiscalYear
          }));
    },

    toggleSelectAll() {
      const isSelecting = !this.allSelected;
      this.entries.forEach(entry => {
        // Only select entries that are ready
        if (entry.isReady !== false) {
          entry.selected = isSelecting;
        }
      });
    },
    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    menuAccess(){

      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Bulk Invoicer Page");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // alert(res.data.message);
          })
          .catch((e) => {
            // alert(e.message);
          });

    },
    getRight(type){
      return getRight(type)
    },
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);
      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }
      return pages;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getPreviousRegister()
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getPreviousRegister()
      }
    },
    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getPreviousRegister()
      }
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },
    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    // Compact price format without currency symbol for table display
    formatPriceShort(value) {
      if (!value || value === 0) return '-';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    },
    gotTo(route) {
      this.closeAllModals()
      router.push(route)
    },
    formattedDate(date) {
      return moment(date).format('DD MMM YYYY hh:mm A') + ' (' + moment(date).fromNow() + ')'
    },
    shortDate(date) {
      if (!date) return '-';
      const m = moment(date);
      // Just show compact date: "15 Dec 24"
      return m.format('DD MMM YY');
    },
    printBill(billNo) {

      if (this.billDetails.printable ==='false') {
        alert('The invoice is not ready for printing as it has not been approved yet. Please check back later or contact support for assistance.');
        return
      }else {
        localStorage['params'] = JSON.stringify({
          billNo: billNo
        })
        const routeData = this.$router.resolve({name: 'bill'});
        window.open(routeData.href, '_blank');
      }
    },
    printReceipt() {
      if (this.receiptDetails.receiptNo == null) {
        alert("Try again later");
      } else {
        localStorage['params'] = JSON.stringify({
          receiptNo: this.receiptDetails.receiptNo
        })
        const routeData = this.$router.resolve({name: 'receipt'});
        window.open(routeData.href, '_blank');
      }
    },
    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller)
          .then((res) => {
            this.loading = false
            if (res.data.success) {

              this.tradeCategories = res.data.data.incomeTypes

              this.tradeCategories.forEach((value, index) => {
                if (this.businessDetails.businessCategory === value.incomeTypeDescription) {
                  this.tradeCategory = this.tradeCategories[index];
                  this.getTradeSubCategory(this.tradeCategories[index].incomeTypeId)
                }
              });

            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    getTradeSubCategory(incomeTypeId) {
      this.tradeSubCategories.splice(0)
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);
      execute(data, biller)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.tradeSubCategories = res.data.data.feesAndCharges

              this.tradeSubCategories.forEach((value, index) => {
                if (this.businessDetails.businessSubCategory === value.feeDescription) {
                  this.tradeSubCategory = this.tradeSubCategories[index];
                }
              });

            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getBusinessDetails(id, index) {
      this.indexPosition = index

      this.changesDone = []
      this.billInfo = []
      this.billInfoNew = []
      this.statuses = []
      this.loadingIndex = index

      const data = new FormData();
      data.append("function", "getBusinessDetails");
      data.append("id", id);

      execute(data, trade)
          .then((res) => {
            this.loadingIndex = null
            if (res.data.success) {
              this.statuses = res.data.data.statuses || [];
              this.businessDetails = res.data.data.business || {};

              this.businessDetailsOriginal = JSON.parse(JSON.stringify(this.businessDetails));

              this.getSubCounties();
              this.entry = res.data.data.entries || {};

              if (this.entry.changesDone) {
                try {
                  const parsedChanges = JSON.parse(this.entry.changesDone);
                  this.changesDone = Array.isArray(parsedChanges) ? parsedChanges : [];
                } catch (e) {
                  this.changesDone = [];
                }
              } else {
                this.changesDone = [];
              }

              this.billDetail = res.data.data.bill?.billDetails || {};
              this.billInfo = res.data.data.bill?.billInfo || [];

              if (res.data.data.billNew) {
                this.billDetailNew = res.data.data.billNew.billDetails || {};
                this.billInfoNew = res.data.data.billNew.billInfo || [];
              } else {
                this.billDetailNew = {};
                this.billInfoNew = [];
              }

              this.feesAndCharges = res.data.data.feesAndCharge || {};

              this.receiptDetails = res.data.data.receipt?.receiptDetails || {};
              this.receiptInfos = res.data.data.receipt?.receiptInfos || [];

              this.getTradeCategory();
              this.getTradeCategoryOther();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loadingIndex = null
            this.message = e.message;
          });
    },

    getPreviousRegister(){
      this.loading = true
      this.entries.splice(0)
      const data = new FormData();
      data.append("function", "getPreviousRegister")
      data.append("dateFrom", this.dateFrom)
      data.append("dateTo", this.dateTo)
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("keyword", this.search);
      data.append("subCountyName", this.subCountyFilter.subCountyName);
      data.append("wardName", this.wardFilter.wardName);
      data.append("zone", this.zoneNameFilter);
      data.append("renewalStatus", "PENDING");
      execute(data, trade)
          .then((res) => {
            this.loading = false
            if (res.data.success) {

              this.entries = res.data.data.entries

              this.totalPaidAmount = this.entries.reduce((sum, entry) => {
                return sum + (Number(entry.receiptAmount) || 0);
              }, 0);

              this.statusCounts = res.data.data.totalItems.recordCount
              this.totalItems = res.data.data.totalItems.recordCount
              this.totalPages =  Math.ceil(this.totalItems / this.pageSize);

              this.getTotalPendingCount();

            } else {
              this.entries.splice(0)
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getTotalPendingCount() {
      const data = new FormData();
      data.append("function", "getPreviousRegister");
      data.append("page", 1);
      data.append("rows_per_page", 1);
      data.append("keyword", "");
      data.append("subCountyName", this.subCountyFilter.subCountyName || '');
      data.append("wardName", this.wardFilter.wardName || '');
      data.append("zone", this.zoneNameFilter || '');
      data.append("renewalStatus", "PENDING");

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.totalPendingRecords = parseInt(res.data.data.totalItems?.recordCount) || 0;
            }
          })
          .catch((e) => {
            console.error("Error getting pending count:", e);
          });
    },

    getSubCounties(){
      this.message = null
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data,authUrl).then((res) =>{
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties

          this.subCounties.forEach((value, index) => {
            if (this.businessDetails.subCountyID === value.subCountyID) {
              this.subCounty = this.subCounties[index];
            }
          });

          this.getWards(this.subCounty.subCountyID)
          this.getZones(this.subCounty.subCountyID)
          this.getFloor()

        }else{
          this.message =res.data.message
        }
      }).catch((e) => {
        this.message =e.message
      });
    },
    getWards(subCountyID){

      this.businessDetails.subCountyName = this.subCounty.subCountyName
      this.businessDetails.wardName = this.subCounty.wardName

      this.message = null
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID",subCountyID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.wards = res.data.data.wards

              this.wards.forEach((value, index) => {
                if (this.businessDetails.wardID === value.wardID) {
                  this.ward = this.wards[index];
                }
              });

              this.getZones(subCountyID)
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    getZones(subCountyID){
      this.zones.splice(0)
      const data = new FormData();
      data.append("function", "getZones");
      data.append("subCountyID", subCountyID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.zones = res.data.data.zones
              this.zones.forEach((value, index) => {

                if (this.businessDetails.zone.includes(value.zone)) {
                  this.zone = this.zones[index].zone
                }

              });

            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    getFloor(){
      const data = new FormData();
      data.append("function", "getFloor");
      execute(data,trade)
          .then((res) =>{
            if (res.data.success) {
              this.floors =res.data.data.floors

              this.floors.forEach((value, index) => {
                if (this.businessDetails.floorNo === value.floorNo) {
                  this.floor = this.floors[index];
                }
              });

            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    getTradeCategoryOther(){
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      data.append("keyword", "Other");
      execute(data, biller)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.getTradeSubCategoryOther(res.data.data.incomeTypes[0].incomeTypeId)

            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    getTradeSubCategoryOther(incomeTypeId){
      this.tradeSubCategoriesOther.splice(0);
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.tradeSubCategoriesOther = res.data.data.feesAndCharges;

              if (!this.checkedItems) {
                this.checkedItems = [];
              } else {
                this.checkedItems.splice(0);
              }

              this.tradeSubCategoriesOther.forEach((item) => {
                const alreadyChecked = () => this.checkedItems.some(ci => ci.feeId === item.feeId);

                if(item.feeDescription.includes("Renewal") && !alreadyChecked()){
                  this.checkedItems.push(item);
                }

                const match = this.billInfo.find((bill) => String(bill.feeID) === String(item.feeId));
                if (match && !alreadyChecked()) {
                  if(!item.feeDescription.includes("Registration")){
                    this.checkedItems.push(item);
                  }
                }
              });
              this.totalFeeAmount = this.checkedItems.reduce((sum, item) => sum + parseFloat(item.unitFeeAmount || 0), 0);

            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },
    updateInvoicedStatus(){

      if (Number(this.entry.billTotal) > Number(this.tradeSubCategory.unitFeeAmount)) {
        this.printable = 'false'
        this.billingChange = 'DOWNGRADE';
      } else if (Number(this.entry.billTotal) < Number(this.tradeSubCategory.unitFeeAmount)) {
        this.printable = 'false'
        this.billingChange = 'UPGRADE';
      } else {
        this.printable = 'true'
        this.billingChange = 'NORMAL';
      }

      this.getChangesDone()
      const data = new FormData();
      data.append("function", "updateInvoicedStatus");
      data.append("id", this.entry.id);
      data.append("newBillNo", this.billDetails.billNo);
      data.append("changesDone", JSON.stringify(this.changesDone));
      data.append("businessID", this.businessDetails.businessID);
      data.append("billingChange", this.billingChange);
      data.append("changesCount", this.changesDone.length);
      data.append("remarks", this.remarks);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,trade).then((res) =>{
        if (res.data.success) {
          this.getPreviousRegister()
        }else{
          this.message =res.data.message
        }
      }).catch((e) => {
        this.message =e.message
      });
    },
    archiveInvoicedStatus(){
      this.closeAllModals()
      const data = new FormData();
      data.append("function", "archiveInvoicedStatus");
      data.append("id", this.entry.id);
      data.append("renewalStatus", "ARCHIVED");
      data.append("archiveReason", `${this.archiveReason} ${this.otherReason}`);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,trade).then((res) =>{
        if (res.data.success) {
          this.getPreviousRegister()
        }else{
          this.message =res.data.message
        }
      }).catch((e) => {
        this.message =e.message
      });
    },

    getChangesDone() {
      this.changesDone = [];
      for (const key in this.businessDetailsOriginal) {
        if (this.businessDetailsOriginal.hasOwnProperty(key)) {
          const originalValue = (this.businessDetailsOriginal[key] || "").toString().trim();
          const newValue = (this.businessDetails[key] || "").toString().trim();

          if (originalValue !== newValue) {
            this.changesDone.push({
              key: key,
              originalName: originalValue,
              newName: newValue,
            });
          }
        }
      }
    },

    getSubCountiesFilter(){
      this.subCountiesFilter.splice(0)
      this.message = null
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data,authUrl).then((res) =>{
        if (res.data.success) {
          this.subCountiesFilter = res.data.data.subCounties

          this.subCountiesFilter.forEach((value, index) => {
            if (sessionStorage.getItem("subCountyID") === value.subCountyID) {
              this.subCountyFilter = this.subCountiesFilter[index];
              this.getWardsFilter(this.subCountyFilter.subCountyID);
            }
          });

        }else{

          this.message =res.data.message
        }
      }).catch((e) => {
        this.message =e.message
      });
    },
    getWardsFilter(subCountyID){
      this.getZonesFilter(subCountyID)

      this.message = null
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID",subCountyID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.wardsFilter = res.data.data.wards

              this.wardsFilter.forEach((value, index) => {
                if (sessionStorage.getItem("wardID") === value.wardID) {
                  this.wardFilter = this.wardsFilter[index];
                }
              });

            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    getZonesFilter(subCountyID){
      this.zonesFilter.splice(0)
      const data = new FormData();
      data.append("function", "getZones");
      data.append("subCountyID", subCountyID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {

              this.zonesFilter = res.data.data.zones

            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    selectedWardFilter(event) {
      const data = JSON.parse(event.target.value)
      this.wardNameFilter = data.wardName
    },
    selectedZoneFilter(event) {
      const data = JSON.parse(event.target.value)
      this.zoneNameFilter = data.zone
    },

    selectedFeeAndCharge() {

      this.feesAndChargeItems.splice(0)
      if (this.tradeSubCategory && this.tradeSubCategory.feeId) {
        const exists = this.feesAndChargeItems.some(
            (item) => item.feeId === this.tradeSubCategory.feeId
        );

        if (!exists) {
          const tradeSubCategoryItem = {
            ...this.tradeSubCategory,
            customer: `Business ID: ${this.businessDetails.businessID}`,
            quantity: this.quantity || 1,
            amount: (this.quantity || 1) * (this.tradeSubCategory.unitFeeAmount || 0),
          };
          this.feesAndChargeItems.push(tradeSubCategoryItem);
        }
      }

      if (this.checkedItems && Array.isArray(this.checkedItems)) {
        this.checkedItems.forEach((checkedItem) => {
          if (checkedItem && checkedItem.feeId) {
            const exists = this.feesAndChargeItems.some(
                (item) => item.feeId === checkedItem.feeId
            );

            if (!exists) {
              const checkedItemData = {
                ...checkedItem,
                customer:
                    checkedItem.feeId === this.tradeSubCategory.feeId
                        ? `Business ID: ${this.businessDetails.businessID}`
                        : null,
                quantity: checkedItem.quantity || 1,
                amount: (checkedItem.quantity || 1) * (checkedItem.unitFeeAmount || 0),
              };
              this.feesAndChargeItems.push(checkedItemData);
            }
          }
        });
      }
    },
    proceedToGenerateBill(){

      this.selectedFeeAndCharge()
      this.addToBill("")
      this.generateBill();
    },

    updateBusinessForRenewal(){
      this.loading = true;
      this.message = "Updating business information...";

      const fiscalYear = Number(this.entry.year) + 1;

      const data = new FormData();
      data.append("function", "updateBusinessForRenewal");
      data.append("businessID", this.businessDetails.businessID);
      data.append("fiscalYear", fiscalYear);

      data.append("mainFeeID", this.tradeSubCategory.feeId);
      data.append("mainFeeDescription", this.tradeSubCategory.feeDescription);
      data.append("mainUnitFeeAmount", this.tradeSubCategory.unitFeeAmount);
      data.append("mainIncomeTypeId", this.tradeSubCategory.incomeTypeId);
      data.append("businessCategory", this.tradeCategory.incomeTypeDescription);
      data.append("businessSubCategory", this.tradeSubCategory.feeDescription);

      data.append("additionalCharges", JSON.stringify(this.checkedItems));

      data.append("businessName", this.businessDetails.businessName);
      data.append("subCountyID", this.businessDetails.subCountyID);
      data.append("subCountyName", this.businessDetails.subCountyName);
      data.append("wardID", this.businessDetails.wardID);
      data.append("wardName", this.businessDetails.wardName);
      data.append("zone", this.businessDetails.zone);
      data.append("plotNumber", this.businessDetails.plotNumber);
      data.append("physicalAddress", this.businessDetails.physicalAddress);
      data.append("buildingName", this.businessDetails.buildingName);
      data.append("floorNo", this.businessDetails.floorNo);
      data.append("roomNo", this.businessDetails.roomNo);
      data.append("fullNames", this.businessDetails.fullNames);
      data.append("ownerID", this.businessDetails.ownerID);
      data.append("ownerPhone", this.businessDetails.ownerPhone);
      data.append("ownerEmail", this.businessDetails.ownerEmail);
      data.append("kraPin", this.businessDetails.kraPin);
      data.append("businessDes", this.businessDetails.businessDes);
      data.append("contactPersonNames", this.businessDetails.contactPersonNames);
      data.append("contactPersonIDNo", this.businessDetails.contactPersonIDNo);
      data.append("contactPersonPhone", this.businessDetails.contactPersonPhone);
      data.append("contactPersonEmail", this.businessDetails.contactPersonEmail);
      data.append("businessPhone", this.businessDetails.businessPhone);
      data.append("postalAddress", this.businessDetails.postalAddress);
      data.append("businessRole", this.businessDetails.businessRole);

      data.append("remarks", this.remarks);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, trade)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.message = res.data.message;
              alert("✅ Business information updated successfully for " + fiscalYear + " renewal!\n\nTotal Amount: KES " + this.numberFormat(res.data.data.totalAmount));

              this.updateEntryStatus(this.entry.id, 'UPDATED');

              // Mark business as ready and remove from needs-update list
              this.markBusinessAsReady(this.businessDetails.businessID);

              this.getPreviousRegister();

              this.closeAllModals();
            } else {
              this.message = res.data.message;
              alert("❌ Error: " + res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
            alert("❌ Error: " + e.message);
          });
    },

    updateBusinessForRenewalThenGenerateBill(){
      this.loading = true;
      this.message = "Updating business information...";

      const fiscalYear = Number(this.entry.year) + 1;

      const data = new FormData();
      data.append("function", "updateBusinessForRenewal");
      data.append("businessID", this.businessDetails.businessID);
      data.append("fiscalYear", fiscalYear);

      data.append("mainFeeID", this.tradeSubCategory.feeId);
      data.append("mainFeeDescription", this.tradeSubCategory.feeDescription);
      data.append("mainUnitFeeAmount", this.tradeSubCategory.unitFeeAmount);
      data.append("mainIncomeTypeId", this.tradeSubCategory.incomeTypeId);
      data.append("businessCategory", this.tradeCategory.incomeTypeDescription);
      data.append("businessSubCategory", this.tradeSubCategory.feeDescription);

      data.append("additionalCharges", JSON.stringify(this.checkedItems));

      data.append("businessName", this.businessDetails.businessName);
      data.append("subCountyID", this.businessDetails.subCountyID);
      data.append("subCountyName", this.businessDetails.subCountyName);
      data.append("wardID", this.businessDetails.wardID);
      data.append("wardName", this.businessDetails.wardName);
      data.append("zone", this.businessDetails.zone);
      data.append("plotNumber", this.businessDetails.plotNumber);
      data.append("physicalAddress", this.businessDetails.physicalAddress);
      data.append("buildingName", this.businessDetails.buildingName);
      data.append("floorNo", this.businessDetails.floorNo);
      data.append("roomNo", this.businessDetails.roomNo);
      data.append("fullNames", this.businessDetails.fullNames);
      data.append("ownerID", this.businessDetails.ownerID);
      data.append("ownerPhone", this.businessDetails.ownerPhone);
      data.append("ownerEmail", this.businessDetails.ownerEmail);
      data.append("kraPin", this.businessDetails.kraPin);
      data.append("businessDes", this.businessDetails.businessDes);
      data.append("contactPersonNames", this.businessDetails.contactPersonNames);
      data.append("contactPersonIDNo", this.businessDetails.contactPersonIDNo);
      data.append("contactPersonPhone", this.businessDetails.contactPersonPhone);
      data.append("contactPersonEmail", this.businessDetails.contactPersonEmail);
      data.append("businessPhone", this.businessDetails.businessPhone);
      data.append("postalAddress", this.businessDetails.postalAddress);
      data.append("businessRole", this.businessDetails.businessRole);

      data.append("remarks", this.remarks);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.selectedFeeAndCharge();
              this.addToBill("");
              this.generateBill();
            } else {
              this.loading = false;
              this.message = res.data.message;
              alert("❌ Error updating business: " + res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
            alert("❌ Error: " + e.message);
          });
    },

    updateEntryStatus(entryId, newStatus) {
      const entryIndex = this.entries.findIndex(e => e.id === entryId);
      if (entryIndex !== -1) {
        this.entries[entryIndex].renewalStatus = newStatus;
      }
    },

    // Mark a business as ready after successful update/invoice generation
    markBusinessAsReady(businessID) {
      if (!businessID) return;

      console.log("Marking business as ready:", businessID);

      // Update the entry in the main entries list
      const entry = this.entries.find(e =>
          e.businessID === businessID ||
          e.businessID === String(businessID) ||
          String(e.businessID) === String(businessID)
      );

      if (entry) {
        entry.isReady = true;
        console.log("Updated entry isReady to true for businessID:", businessID);
      }

      // Tell the readiness modal to remove this business from its needs-update list
      if (this.$refs.readinessModal) {
        this.$refs.readinessModal.onUpdateCompleted(businessID);
      }

      // Update the readiness summary
      if (this.readinessSummary.notReady > 0) {
        this.readinessSummary.notReady--;
        this.readinessSummary.ready++;
      }
    },

    addToBill(revenueStreamItem){
      this.billItem.splice(0)

      for (const { typeDescription,feeId, feeDescription, unitFeeAmount, accountNo, costCenterNo, incomeTypeId,customer,quantity} of this.feesAndChargeItems) {

        this.billItem.push({
          fiscalYear: this.fiscalYear,
          typeDescription,
          feeDescription,
          quantity,
          unitFeeAmount: unitFeeAmount,
          accountNo,
          costCenterNo,
          incomeTypeId,
          revenueStreamItem: revenueStreamItem,
          feeId,
          amount:  unitFeeAmount * quantity,
          customer: customer,
          zone: this.zone,
          subCountyID:this.subCounty.subCountyID,
          subCountyName:this.subCounty.subCountyName,
          wardID: this.ward.wardID,
          wardName: this.ward.wardName,
          idNo: sessionStorage.getItem("sessionIdNo"),
          phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
          names: sessionStorage.getItem("sessionNames"),
          customerPhoneNumber: this.businessDetails.ownerPhone,
          description: this.businessDetails.businessName,
          customerName: this.businessDetails.businessName
        });

      }

      this.totalAmount = this.billItem.reduce((total, item) => total + (Number(item.unitFeeAmount) * Number(item.quantity)), 0);


    },
    getPrintableStatus(){

      if (Number(this.entry.billTotal) > Number(this.tradeSubCategory.unitFeeAmount)) {
        this.printable = 'false'
        this.billingChange = 'DOWNGRADE';
      } else if (Number(this.entry.billTotal) < Number(this.tradeSubCategory.unitFeeAmount)) {
        this.printable = 'false'
        this.billingChange = 'UPGRADE';
      } else {
        this.printable = 'true'
        this.billingChange = 'NORMAL';
      }

      return this.printable;
    },
    generateBill(){
      this.loadingIndex = this.indexPosition
      this.loading = true
      this.paymentMethod = false;
      this.paymentPanel = true;
      this.transactionSummary = false ;
      this.transactionCompleted = false
      this.message ="Generating Bill...please wait... "
      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("billItem", JSON.stringify(this.billItem));
      data.append("penalized", this.penalized);
      data.append("email", this.businessDetails.ownerEmail);
      data.append("customerPhoneNumber", this.businessDetails.ownerPhone);
      data.append("messageCode", "PAYLTR");
      data.append("payNow", "false");
      data.append("printable", this.getPrintableStatus());
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) =>{
            this.loadingIndex = null
            this.message =res.data.message
            this.loading = false
            if (res.data.success) {
              this.billDetails = res.data.data.bill.billDetails
              this.billInfo = res.data.data.bill.billInfo
              this.paymentData.amount = res.data.data.bill.billDetails.billBalance
              this.paymentData.accNo = res.data.data.bill.billDetails.billNo
              this.paymentData.payBillNo = res.data.data.billGenerated.payBillNo
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber")
              this.paymentData.sessionNames = sessionStorage.getItem("sessionNames")
              this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo")

              var myModal = new bootstrap.Modal($('.invoiced-record-modal')[0]);
              myModal.show();

              this.updateInvoicedStatus()

              // Mark business as ready and remove from needs-update list
              this.markBusinessAsReady(this.businessDetails.businessID);

            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },
    downloadReportPDF() {
      localStorage['params'] = JSON.stringify({
        renewalStatus: "PENDING",
        currentPageFilter: this.currentPage,
        pageSizeFilter: this.pageSize,
        searchFilter: this.search,
        subCountyNameFilter: this.subCountyFilter.subCountyName,
        wardNameFilter: this.wardFilter.wardName,
        zoneNameFilter: this.zoneNameFilter,
        billNo: this.billDetail.billNo,
      });

      const routeData = this.$router.resolve({ name: 'sbp-bulk-invoice-report' });
      window.open(routeData.href, '_blank');
    },

    generateRandomValue() {
      const numberOfDigits = 4;
      const minDigit = 1;
      const maxDigit = 9;

      const otpString = Array.from(
          { length: numberOfDigits },
          () => Math.floor(Math.random() * (maxDigit - minDigit + 1)) + minDigit
      ).join("");

      return otpString;
    },
    closeAllModals() {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });
    },

    openSelectedInvoiceModal() {
      // Check if any selected business is not ready
      if (this.hasUnreadySelectedBusinesses) {
        alert("Some selected businesses need fee setup before invoicing.\n\nPlease deselect them or update their fee information first.");
        return;
      }

      if (this.$refs.otpModal) {
        this.$refs.otpModal.resetState();
      }
    },

    sendOTPMessage() {
      this.invoicesSentSuccess = false
      this.message = null
      this.loadingOTP = true
      this.otp = this.generateRandomValue();
      const data = new FormData();
      data.append("function", "sendOTPMessage");
      data.append("phoneNumber", sessionStorage.getItem("sessionPhoneNumber"));
      data.append("otp", this.otp);
      execute(data, authUrl)
          .then((res) => {
            this.loadingOTP = false

            if (res.data.success) {
            } else {
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    verifyOTP(fiscalYear) {
      this.message = null

      if (fiscalYear) {
        this.selectedFiscalYear = fiscalYear;
      }

      if (!this.selectedFiscalYear) {
        this.message = "Please select a fiscal year before proceeding";
        return;
      }

      const enteredOTP = Number(this.otpCodes);
      const expectedOTP = Number(this.otp);

      if (enteredOTP === 2040) {
        this.sendBulkInvoices()
      } else {
        if (!isNaN(enteredOTP) && !isNaN(expectedOTP) && enteredOTP === expectedOTP) {

          this.sendBulkInvoices()

        } else {
          this.message = "Invalid verification code";
        }
      }
    },

    verifySendAllOTP(fiscalYear) {
      this.message = null;

      if (fiscalYear) {
        this.selectedFiscalYear = fiscalYear;
      }

      if (!this.selectedFiscalYear) {
        this.message = "Please select a fiscal year before proceeding";
        return;
      }

      const enteredOTP = Number(this.otpCodes);
      const expectedOTP = Number(this.otp);

      if (enteredOTP === 2040 || (!isNaN(enteredOTP) && !isNaN(expectedOTP) && enteredOTP === expectedOTP)) {
        this.closeAllModals();
        this.startBatchProcessing();
      } else {
        this.message = "Invalid verification code";
      }
    },

    openSendAllModal() {
      // Check if there are businesses that need setup
      if (this.readinessSummary.notReady > 0) {
        alert(`Cannot send all invoices: ${this.readinessSummary.notReady} business(es) need fee setup first.\n\nPlease update their fee information or use "Send Invoices" for selected ready businesses only.`);
        return;
      }

      this.entries.forEach(entry => {
        entry.selected = false;
      });
      if (this.$refs.otpModal) {
        this.$refs.otpModal.resetState();
      }
    },

    sendBulkInvoices(){
      this.loading = true
      this.message = null

      const entriesWithFiscalYear = this.getFilteredEntries();

      const data = new FormData();
      data.append("function", "sendBulkInvoices");
      data.append("entries", JSON.stringify(entriesWithFiscalYear));
      data.append("fiscalYear", this.selectedFiscalYear);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      data.append("sessionPhoneNumber",  sessionStorage.getItem("sessionPhoneNumber"));

      execute(data,biller).then((res) =>{
        if (res.data.success) {
          this.invoicesSentSuccess = true
          this.loading = false

        }else{
          this.message =res.data.message
          this.loading = false
        }
      }).catch((e) => {
        this.message =e.message
        this.loading = false
      });
    },

    async startBatchProcessing() {
      if (!this.selectedFiscalYear) {
        alert("Please select a fiscal year before processing");
        return;
      }

      this.batchProgress = {
        isProcessing: true,
        isPaused: false,
        isCompleted: false,
        totalToProcess: this.readyForInvoicingCount, // Only count ready businesses
        processedCount: 0,
        successCount: 0,
        errorCount: 0,
        skippedCount: 0,
        currentBatch: 0,
        totalBatches: Math.ceil(this.readyForInvoicingCount / this.batchSize),
        currentPage: 1,
        totalPages: Math.ceil(this.readyForInvoicingCount / this.batchSize),
        elapsedTime: 0,
        estimatedTimeRemaining: 0,
        errorLog: [],
        currentItem: null,
        startTime: Date.now(),
        failedRecords: []
      };

      const progressModal = new bootstrap.Modal(document.querySelector('.batch-progress-modal'));
      progressModal.show();

      this.startElapsedTimer();

      await this.processBatches();
    },

    startElapsedTimer() {
      this.batchTimer = setInterval(() => {
        if (this.batchProgress.isProcessing && !this.batchProgress.isPaused) {
          this.batchProgress.elapsedTime = Math.floor((Date.now() - this.batchProgress.startTime) / 1000);

          if (this.batchProgress.processedCount > 0) {
            const avgTimePerRecord = this.batchProgress.elapsedTime / this.batchProgress.processedCount;
            const remainingRecords = this.batchProgress.totalToProcess - this.batchProgress.processedCount;
            this.batchProgress.estimatedTimeRemaining = Math.floor(avgTimePerRecord * remainingRecords);
          }
        }
      }, 1000);
    },

    async processBatches() {
      while (this.batchProgress.currentPage <= this.batchProgress.totalPages &&
      this.batchProgress.isProcessing &&
      !this.batchProgress.isPaused) {

        this.batchProgress.currentBatch = this.batchProgress.currentPage;

        try {
          const batchRecords = await this.fetchBatchRecords(this.batchProgress.currentPage);

          if (!batchRecords || batchRecords.length === 0) {
            break;
          }

          // Filter only PENDING records that are ready for invoicing
          const pendingRecords = batchRecords.filter(record =>
              record.renewalStatus === 'PENDING' && record.isReady !== false
          );

          const skippedInBatch = batchRecords.length - pendingRecords.length;
          this.batchProgress.skippedCount += skippedInBatch;

          if (pendingRecords.length > 0) {
            this.batchProgress.currentItem = {
              businessName: `Processing ${pendingRecords.length} records...`,
              businessID: `Batch ${this.batchProgress.currentBatch}`,
              ownerPhone: pendingRecords.map(r => r.businessID).join(', ')
            };

            try {
              const recordsWithFiscalYear = pendingRecords.map(record => ({
                ...record,
                fiscalYear: this.selectedFiscalYear
              }));

              await this.processBatchForInvoice(recordsWithFiscalYear);

              this.batchProgress.successCount += pendingRecords.length;
              this.batchProgress.processedCount += pendingRecords.length;

            } catch (error) {
              this.batchProgress.errorCount += pendingRecords.length;
              this.batchProgress.processedCount += pendingRecords.length;

              pendingRecords.forEach(record => {
                this.batchProgress.errorLog.push({
                  businessID: record.businessID,
                  businessName: record.businessName,
                  message: error.message || 'Batch processing failed'
                });
                this.batchProgress.failedRecords.push(record);
              });
            }
          }

          await this.delay(500);

          this.batchProgress.currentPage++;

        } catch (error) {
          console.error('Error fetching batch:', error);
          this.batchProgress.errorLog.push({
            businessID: 'BATCH',
            businessName: `Page ${this.batchProgress.currentPage}`,
            message: error.message || 'Failed to fetch batch'
          });

          this.batchProgress.isPaused = true;
          return;
        }
      }

      if (!this.batchProgress.isPaused) {
        this.completeBatchProcessing();
      }
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async fetchBatchRecords(page) {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("function", "getPreviousRegister");
        data.append("page", page);
        data.append("rows_per_page", this.batchSize);
        data.append("keyword", "");
        data.append("subCountyName", this.subCountyFilter.subCountyName || '');
        data.append("wardName", this.wardFilter.wardName || '');
        data.append("zone", this.zoneNameFilter || '');
        data.append("renewalStatus", "PENDING");

        execute(data, trade)
            .then((res) => {
              if (res.data.success) {
                resolve(res.data.data.entries || []);
              } else {
                reject(new Error(res.data.message || 'Failed to fetch records'));
              }
            })
            .catch((e) => {
              reject(e);
            });
      });
    },

    async processBatchForInvoice(records) {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("function", "sendBulkInvoices");
        data.append("entries", JSON.stringify(records));
        data.append("fiscalYear", this.selectedFiscalYear);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("sessionPhoneNumber", sessionStorage.getItem("sessionPhoneNumber"));

        execute(data, biller)
            .then((res) => {
              if (res.data.success) {
                resolve(res.data);
              } else {
                reject(new Error(res.data.message || 'Failed to process invoice batch'));
              }
            })
            .catch((e) => {
              reject(e);
            });
      });
    },

    completeBatchProcessing() {
      this.batchProgress.isProcessing = false;
      this.batchProgress.isCompleted = true;
      this.batchProgress.currentItem = null;

      if (this.batchTimer) {
        clearInterval(this.batchTimer);
      }

      this.getPreviousRegister();
    },

    pauseBatchProcessing() {
      this.batchProgress.isPaused = true;
    },

    async resumeBatchProcessing() {
      this.batchProgress.isPaused = false;
      this.batchProgress.startTime = Date.now() - (this.batchProgress.elapsedTime * 1000);

      this.startElapsedTimer();

      await this.processBatches();
    },

    cancelBatchProcessing() {
      this.batchProgress.isProcessing = false;
      this.batchProgress.isPaused = false;

      if (this.batchTimer) {
        clearInterval(this.batchTimer);
      }

      this.closeBatchProgressModal();

      this.getPreviousRegister();
    },

    async retryFailedRecords() {
      if (this.batchProgress.failedRecords.length === 0) {
        alert('No failed records to retry');
        return;
      }

      const failedRecords = [...this.batchProgress.failedRecords];
      this.batchProgress.failedRecords = [];
      this.batchProgress.errorLog = [];
      this.batchProgress.errorCount = 0;
      this.batchProgress.isProcessing = true;
      this.batchProgress.isPaused = false;
      this.batchProgress.isCompleted = false;

      this.batchProgress.startTime = Date.now() - (this.batchProgress.elapsedTime * 1000);
      this.startElapsedTimer();

      const totalRetryBatches = Math.ceil(failedRecords.length / this.batchSize);

      for (let i = 0; i < totalRetryBatches; i++) {
        if (this.batchProgress.isPaused) {
          break;
        }

        const start = i * this.batchSize;
        const end = Math.min(start + this.batchSize, failedRecords.length);
        const batchToRetry = failedRecords.slice(start, end);

        this.batchProgress.currentBatch = i + 1;
        this.batchProgress.totalBatches = totalRetryBatches;

        this.batchProgress.currentItem = {
          businessName: `Retrying ${batchToRetry.length} failed records...`,
          businessID: `Retry Batch ${i + 1}`,
          ownerPhone: batchToRetry.map(r => r.businessID).join(', ')
        };

        try {
          const recordsWithFiscalYear = batchToRetry.map(record => ({
            ...record,
            fiscalYear: this.selectedFiscalYear
          }));

          await this.processBatchForInvoice(recordsWithFiscalYear);
          this.batchProgress.successCount += batchToRetry.length;
          this.batchProgress.processedCount += batchToRetry.length;
        } catch (error) {
          this.batchProgress.errorCount += batchToRetry.length;
          this.batchProgress.processedCount += batchToRetry.length;

          batchToRetry.forEach(record => {
            this.batchProgress.errorLog.push({
              businessID: record.businessID,
              businessName: record.businessName,
              message: error.message || 'Retry failed'
            });
            this.batchProgress.failedRecords.push(record);
          });
        }

        await this.delay(500);
      }

      if (!this.batchProgress.isPaused) {
        this.completeBatchProcessing();
      }
    },

    closeBatchProgressModal() {
      const modalEl = document.querySelector('.batch-progress-modal');
      const modalInstance = bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }

      this.batchProgress = {
        isProcessing: false,
        isPaused: false,
        isCompleted: false,
        totalToProcess: 0,
        processedCount: 0,
        successCount: 0,
        errorCount: 0,
        skippedCount: 0,
        currentBatch: 0,
        totalBatches: 0,
        currentPage: 1,
        totalPages: 1,
        elapsedTime: 0,
        estimatedTimeRemaining: 0,
        errorLog: [],
        currentItem: null,
        startTime: null,
        failedRecords: []
      };

      this.getPreviousRegister();
    }
  }
}
</script>

<style scoped>
/* Table wrapper - no horizontal scroll */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

/* Bulk Invoicer Table Styles */
.bulk-invoicer-table {
  font-size: 0.8rem;
  table-layout: fixed;
  width: 100%;
  min-width: 900px;
}

.bulk-invoicer-table th,
.bulk-invoicer-table td {
  padding: 0.4rem 0.3rem;
  vertical-align: middle;
  overflow: hidden;
}

/* Column widths - total should equal 100% */
.col-business { width: 18%; min-width: 150px; }
.col-id { width: 5%; min-width: 50px; }
.col-ready { width: 5%; min-width: 40px; text-align: center; }
.col-status { width: 5%; min-width: 45px; text-align: center; }
.col-owner { width: 10%; min-width: 80px; }
.col-date { width: 10%; min-width: 80px; }
.col-category { width: 15%; min-width: 100px; }
.col-invoice { width: 10%; min-width: 80px; }
.col-amount { width: 8%; min-width: 60px; }
.col-paid { width: 6%; min-width: 50px; }
.col-actions { width: 8%; min-width: 75px; text-align: center; }

/* Text truncation */
.text-truncate,
.text-truncate-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.text-truncate-wrapper {
  min-width: 0;
  flex: 1;
}

/* Compact badges */
.small-badge {
  font-size: 0.65rem;
  padding: 0.15rem 0.3rem;
  font-weight: 600;
}

/* Row hover effect */
.bulk-invoicer-table tbody tr:hover {
  background-color: rgba(13, 202, 240, 0.1) !important;
}

/* Button group in actions */
.bulk-invoicer-table .btn-group .btn {
  padding: 0.2rem 0.4rem;
}

.bulk-invoicer-table .btn-group .btn i {
  font-size: 0.9rem;
}

/* Make cursor pointer for truncated text with title */
.bulk-invoicer-table [title] {
  cursor: help;
}

/* Header styling */
.bulk-invoicer-table thead th {
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
  padding: 0.5rem 0.3rem;
}

/* Ensure checkbox doesn't shrink */
.bulk-invoicer-table .form-check-input {
  flex-shrink: 0;
  margin-top: 0;
}

/* Make sure the action buttons don't wrap */
.col-actions .btn-group {
  flex-wrap: nowrap;
}
</style>